import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const Cookies = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-24 px-6 pb-16 max-w-4xl mx-auto text-[#173861]">
      <Helmet>
        <title>{t('cookiesTitle')}</title>
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">{t('cookiesHeader')}</h1>
      <p className="mb-4">{t('cookiesIntro')}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('cookiesTypesTitle')}</h2>
      <ul className="list-disc pl-6 space-y-1">
        <li>{t('cookiesTypes.0')}</li>
        <li>{t('cookiesTypes.1')}</li>
        <li>{t('cookiesTypes.2')}</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('cookiesThirdPartyTitle')}</h2>
      <p className="mb-4">
        {t('cookiesThirdParty')}{' '}
        <a href="https://policies.google.com/privacy" className="underline text-blue-600" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('cookiesManageTitle')}</h2>
      <p className="mb-4">{t('cookiesManage')}</p>

      <h2 className="text-xl font-semibold mt-6 mb-2">{t('cookiesContactTitle')}</h2>
      <p>{t('cookiesContact')}</p>
    </div>
  );
};

export default Cookies;